import { RunAsyncUntilCompleteRequestFailedError } from './RunAsyncUntilCompleteRequestFailedError';
import { RunAsyncUntilCompleteTimedOutError } from './RunAsyncUntilCompleteTimedOutError';
import { runAsyncWithTimeMeasurement } from './runAsyncWithTimeMeasurement';

const defaultTimeoutMs = 240_000;

export type RunAsyncUntilCompleteResult<T> =
  | { type: 'not-completed' }
  | { type: 'completed'; data: T };

export type RunAsyncUntilCompleteOptions = {
  timeoutMs?: number;
};

export function runAsyncUntilComplete<T>(
  fn: () => Promise<RunAsyncUntilCompleteResult<T>>,
  options: RunAsyncUntilCompleteOptions = {},
): Promise<T> {
  const timeoutMs = options.timeoutMs || defaultTimeoutMs;
  let remainingTimeout = timeoutMs;

  const runUntilComplete = async (): Promise<T> => {
    try {
      const { response, deltaTime } = await runAsyncWithTimeMeasurement(fn);

      if (response.type === 'completed') return response.data;

      remainingTimeout -= deltaTime;
    } catch (error) {
      throw new RunAsyncUntilCompleteRequestFailedError(
        (error as Error).message,
      );
    }

    if (remainingTimeout <= 0) {
      throw new RunAsyncUntilCompleteTimedOutError(timeoutMs);
    }

    return runUntilComplete();
  };

  return runUntilComplete();
}
